import * as Yup from "yup";
export const getClientValidationSchema = (tab, isNaturalClient, clients) => {
    if (isNaturalClient) {
      switch (tab) {
        case 1:
          return Yup.object({
            name: Yup.string().required("Please enter first name"),
            surname: Yup.string().required("Please enter last name"),
            country: Yup.string().required("Please enter country"),
            region: Yup.string().required("Please enter region"),
            city: Yup.string().required("Please enter city"),
          });
        case 2:
          return Yup.object({
            postal_code: Yup.string()
              .optional()
              .nullable()
              .matches(/^[0-9]{4,6}$/, "Postal code must be 4-6 digits"),
  
            personal_email: Yup.string()
              .email("Please enter a valid email")
              .matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                "Email must contain a valid domain part (e.g., .com, .org)"
              )
              .required("Please enter email"),
  
            mobile_phone_number: Yup.string()
              .matches(
                /^[0-9]{10,15}$/,
                "Mobile phone number must be 10-15 digits"
              )
              .required("Please enter mobile phone number"),
            address: Yup.string().required("Please enter address"),
          });
  
        case 3:
          const baseSchema = {
            social_security_number: Yup.string()
              .test(
                "unique-ssn",
                "This Social Security already exists",
                function (value) {
                  if (!value) return true;
                  const ssnList = clients.map(
                    (client) => client.social_security_number
                  );
                  return !ssnList.includes(value);
                }
              )
              // .matches(
              //   /^[0-9]{9,14}$/,
              //   "Social security number must be 9-14 digits"
              // )
              .required("Please enter social security number"),
  
            add_second_client: Yup.boolean(),
          };
          
          return Yup.object().shape({
            ...baseSchema,
            
            additional_contact2_name: Yup.string().when('add_second_client', {
              is: true,
              then: () => Yup.string().required("Please enter second client's first name"),
              otherwise: () => Yup.string().notRequired(),
            }),
            additional_contact2_surname: Yup.string().when('add_second_client', {
              is: true,
              then: () => Yup.string().required("Please enter second client's last name"),
              otherwise: () => Yup.string().notRequired(),
            }),
            additional_contact2_ssn: Yup.string().when('add_second_client', {
              is: true,
              then: () => Yup.string()
                .test(
                  "unique-ssn-second",
                  "This Social Security already exists",
                  function (value) {
                    if (!value) return true;
                    const ssnList = clients.map(
                      (client) => client.social_security_number
                    );
                    return !ssnList.includes(value);
                  }
                )
                .test(
                  "different-from-first-ssn",
                  "Second client's SSN cannot be the same as the first client's SSN",
                  function (value) {
                    if (!value) return true;
                    const firstSSN = this.parent.social_security_number;
                    return value !== firstSSN;
                  }
                )
                // .matches(/^[0-9]{9,14}$/, "Social security number must be 9-14 digits")
                .required("Please enter second client's social security number"),
              otherwise: () => Yup.string().notRequired(),
            }),
            additional_contact2_mobile: Yup.string().when('add_second_client', {
              is: true,
              then: () => Yup.string()
                .matches(/^[0-9]{10,15}$/, "Mobile phone number must be 10-15 digits")
                .required("Please enter second client's mobile number"),
              otherwise: () => Yup.string().notRequired(),
            }),
            additional_contact2_email: Yup.string().when('add_second_client', {
              is: true,
              then: () => Yup.string()
                .email("Please enter a valid email")
                .required("Please enter second client's email"),
              otherwise: () => Yup.string().notRequired(),
            }),
          });
  
        default:
          return Yup.object({});
      }
    } else {
      switch (tab) {
        case 1:
          return Yup.object({
            legal_company_name: Yup.string().required(
              "Please enter legal company name"
            ),
  
            legal_fiscal_code: Yup.string()
              .matches(
                /^[A-Z0-9]{8,12}$/,
                "Fiscal code must be alphanumeric and 8-12 characters"
              )
              .required("Please enter legal fiscal code"),
  
            legal_unique_registration_code: Yup.string()
              .test(
                "unique-urc",
                "This unique registration code already exists",
                function (value) {
                  if (!value) return true;
                  const urcList = clients.map(
                    (client) => client.legal_unique_registration_code
                  );
                  return !urcList.includes(value);
                }
              )
              .matches(/^[A-Z0-9]{8,12}$/, "Must be alphanumeric 8-12 chars")
              .required("Please enter unique registration code"),
  
            legal_trade_register_number: Yup.string()
              .matches(
                /^.{7,20}$/,
                "Trade register number must be 7-20 characters long (any characters allowed)"
              )
              .required("Please enter a trade register number"),
          });
        case 2:
          return Yup.object({
            mobile_phone_number: Yup.string()
              .matches(
                /^[0-9]{10,15}$/,
                "Mobile phone number must be 10-15 digits"
              )
              .required("Please enter mobile phone number"),
  
            legal_country: Yup.string().required("Please enter legal country"),
            legal_region: Yup.string().required("Please enter legal region"),
            legal_city: Yup.string().required("Please enter legal city"),
            legal_office_address: Yup.string().required(
              "Please enter legal office address"
            ),
          });
  
        case 3:
          return Yup.object({
            business_email: Yup.string()
              .email("Please enter a valid business email")
              .matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                "Email must contain a valid domain part (e.g., .com, .org)"
              )
              .required("Please enter business email"),
          });
  
        default:
          return Yup.object({});
      }
    }
  };